import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpenIcon, CalendarIcon, UtensilsIcon, ActivityIcon, MoonIcon } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <BookOpenIcon size={28} data-id="element-168" />,
    title: 'El eBook Maestro Protocolo Cortisol Off™',
    desc: 'El paso a paso completo para resetear tu sistema hormonal desde la raíz.'
  }, {
    icon: <CalendarIcon size={28} data-id="element-169" />,
    title: "El Plan de 7 Días 'Vientre Plano'",
    desc: 'Qué hacer exactamente desde que despiertas hasta que duermes para ver cambios reales.'
  }, {
    icon: <UtensilsIcon size={28} data-id="element-170" />,
    title: "Guía de Nutrición que 'Enfría'",
    desc: 'Lista de alimentos específicos que apagan la inflamación celular al instante.'
  }, {
    icon: <ActivityIcon size={28} data-id="element-171" />,
    title: 'Rutina de Micromovimientos Somáticos',
    desc: 'Solo 5 minutos al día para liberar la tensión profunda acumulada en el psoas.'
  }, {
    icon: <MoonIcon size={28} data-id="element-172" />,
    title: 'Checklist de Higiene Nocturna',
    desc: 'Cómo preparar tu cuerpo para evitar el destructivo pico de cortisol de las 3:00 AM.'
  }];
  return <section className="py-24 bg-cream" data-id="element-173">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <FadeIn data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-176">
            ¿Qué incluye el Protocolo Cortisol Off™?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-177">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={`bg-white rounded-3xl p-8 shadow-sm border border-sage-light/30 hover:shadow-md transition-shadow duration-300 ${index === 0 ? 'md:col-span-2 lg:col-span-3 lg:w-2/3 lg:mx-auto' : ''}`} data-id="element-178">
              <div className="w-14 h-14 rounded-2xl bg-sage-light/50 flex items-center justify-center text-sage mb-6" data-id="element-179">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-180">{item.title}</h3>
              <p className="text-brown/70 leading-relaxed" data-id="element-181">{item.desc}</p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}